module.exports = __webpack_public_path__ + "img/carousel-3.982c46bf.webp";